import { useState, useEffect, forwardRef } from 'react';
import moment from 'moment';
import {
    Box, Button, Card, CardContent, CardHeader, Divider,
    Grid,TextField,Typography, Dialog, DialogActions, DialogContent, DialogContentText,
     DialogTitle, TableCell, TableRow, TableBody, TableHead,
} from '@material-ui/core';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import axios from 'axios';
import './AccountProfile.css'
import Cookies from 'universal-cookie';
import { useHistory } from 'react-router';
import { useFormik } from 'formik';
import * as yup from 'yup';
import LearnTable from './LearnTable.js';
const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const AccountProfileDetails = (props) => {
    const [username, setUsername] = useState([]);
    const [user, setUser] = useState('');
    const [userEmail, setUserEmail] = useState('');
    const [names, setNames] = useState('');
    const [userRank, setUserRank] = useState('');
    const [userScore, setUserScore] = useState(0);
    const [institution, setInstitution] = useState('');
    const [role, setRole] = useState('');
    const [openSuccess, setOpenSuccess] = useState(false);
    const [openError, setOpenError] = useState(false);
    const [records, setRecords] = useState([]);
    const [error, setErrorMessage] = useState('');
    const [success, setSuccessMessage] = useState('');
    const [openRemoveDialog, setOpenRemoveDialog] = useState(false);
    const [removeUserID, setRemoveUserID] = useState('');
    const cookies = new Cookies();
    const userToken = cookies.get('tokenCTF');
    const history = useHistory();
    const headCells = [
        { id: 'lugar', label: 'Lugar' },
        { id: 'usuario', label: 'Usuario' },
        { id: 'rank', label: 'Rank' },
        { id: 'puntaje', label: 'Puntaje' },
        
    ]
    useEffect(() => {

        axios.get(`https://${process.env.REACT_APP_BASE_URL}/api/users/profile`, {
            headers: { 'Authorization': userToken }
        }).then(

            (response) => {
                if (response.data.noAuth) {
                    cookies.remove('tokenCTF', { path: '/' });
                    history.push('/login');
                }
                else {
                    if (response.data.error) {
                        setErrorMessage(response.data.error);
                        setOpenError(true);
                    }
                    else {
                        setUser(response.data[0].username);
                        setUsername(response.data[0].username);
                        setUserEmail(response.data[0].email);
                        setNames(response.data[0].name);
                        setInstitution(response.data[0].institution);
                        setRole(response.data[0].role);
                        setErrorMessage('');
                        setOpenError(false);
                    }

                }
            })


    }, [])
    useEffect(() => {
        axios.get(`https://${process.env.REACT_APP_BASE_URL}/api/users/getUserRank`, {
            headers: { 'Authorization': userToken }
        }).then(
            (response) => {
                if (response.data.noAuth) {
                    cookies.remove('tokenCTF', { path: '/' });
                    history.push('/login');
                }
                else {
                        setUserScore(response.data.score);
                        setUserRank(response.data.rank);
                }
            })
        axios.get(`https://${process.env.REACT_APP_BASE_URL}/api/users/getScoreLearn`, {
            headers: { 'Authorization': userToken }
        }).then((response) => {
            if (response.data.noAuth) {
                cookies.remove('tokenCTF', { path: '/' });
                history.push('/login');
            }
            else{
               
                setRecords(response.data);
            }
            })
    }, [])
    //REMOVE USER
    function handleOpenRemoveDialog(username) {
        setOpenRemoveDialog(true);
        setRemoveUserID(username);

    };

    const handleCloseRemoveDialog = () => {
        setOpenRemoveDialog(false);
        setRemoveUserID("");
    };
    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenError(false);
        setOpenSuccess(false);
    };
    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = LearnTable(records, headCells);
    //pass
    const formik = useFormik({
        initialValues: {
            Username: username,
            OldPassword: '',
            Password: '',
            VerifyPassword: ''
        },
        validationSchema: yup.object({
            OldPassword: yup.string().required('Campo requerido *'),
            Password: yup.string()
                .matches(
                    /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
                    "Debe tener mínimo 8 carácteres, una mayúscula, una minúscula, un número y un carácter especial"
                ).required('Campo requerido *'),

            VerifyPassword: yup.string()
                .required('Campo requerido *')
                .oneOf([yup.ref('Password'), null], 'Contraseñas no coinciden'),
        }),
        onSubmit: values => {
            axios.put(`https://${process.env.REACT_APP_BASE_URL}/api/users/passwordUpdate`, {
                oldPassword: values.OldPassword,
                newPassword: values.Password,
            }, {
                headers: { 'Authorization': userToken }
            }).then((response) => {
                if (response.data.noAuth) {
                    cookies.remove('tokenCTF', { path: '/' });
                    history.push('/login');
                }
                else {
                    if (response.data.messageError) {
                        setErrorMessage(response.data.messageError);
                        setOpenError(true);
                    }
                    else if (response.data.messageSuccess) {
                        setSuccessMessage(response.data.messageSuccess);
                        setOpenSuccess(true);
                        formik.resetForm();
                    }
                    else {
                        setErrorMessage('');
                        setSuccessMessage('');
                        setOpenError(false);
                        setOpenSuccess(false);
                    }
                }
            });
        }
    });
    //user
    function updateUser() {
        axios.put(`https://${process.env.REACT_APP_BASE_URL}/api/users/profileUpdate`, {
            username: user,
            name: names,
            email: userEmail,
            institution: institution,
            role: role
        }, {
            headers: { 'Authorization': userToken }
        }).then((response) => {
            if (response.data.noAuth) {
                cookies.remove('tokenCTF', { path: '/' });
                history.push('/login');
            }
            else {
                if (response.data.messageError) {
                    setErrorMessage(response.data.messageError);
                    setOpenError(true);
                }
                else if (response.data.messageSuccess) {
                    setSuccessMessage(response.data.messageSuccess);
                    setOpenSuccess(true);
                }
                else {
                    setErrorMessage('');
                    setSuccessMessage('');
                    setOpenError(false);
                    setOpenSuccess(false);
                }
            }
        })
    };

    function deleteUser(user) {
        axios.delete(`https://${process.env.REACT_APP_BASE_URL}/api/users/userDelete/${user}`, {
            headers: { 'Authorization': userToken }
        }).then((response) => {
            if (response.data.noAuth) {
                cookies.remove('tokenCTF', { path: '/' });
                history.push('/login');
            }
            else {
                if (response.data.messageError) {
                    setErrorMessage(response.data.messageError);
                    setOpenError(true);
                }
                else if (response.data.messageSuccess) {
                    cookies.remove('tokenCTF', { path: '/' });
                    history.push('/login');

                }
                else {
                    setErrorMessage('');
                    setOpenError(false);
                }
            }
        })
    };
    const userLeft = {
        avatar: '/hackerProfile.png',
        jobTitle: 'Estudiante',
        timezone: 'GTM-7'
    };

    return (
        <div className="userProfile">
            <div className='top-card'>
                <Card className="left-user-card">
                    <CardContent>
                        <Box
                            className="boxStyling"
                        >
                            <img
                                src={userLeft.avatar}
                                className="user-avatar"
                                alt=""
                            />
                            <Typography
                                color="textPrimary"
                                gutterBottom
                                variant="h3"
                            >


                                <div>{username}</div>


                            </Typography>
                            <Typography
                                color="textSecondary"
                                variant="body1"
                            >
                                {userRank}
                            </Typography>
                            <Typography
                                color="textSecondary"
                                variant="body1"
                            >
                                Puntaje: {userScore}
                            </Typography>
                            <Typography
                                color="textSecondary"
                                variant="body1"
                            >
                                {`${moment().format('hh:mm A')} ${userLeft.timezone}`}
                            </Typography>
                        </Box>
                    </CardContent>
                    <Divider />
                </Card>
                <div className="right-user-card" >
                    <Card >
                        <CardHeader
                            title="Perfil"
                        />
                        <Divider />
                        <CardContent>
                            <Grid
                                container
                                spacing={3}
                            >
                                <Grid
                                    item
                                    md={6}
                                    xs={12}
                                >

                                    <TextField
                                        fullWidth
                                        label="Nombres Completos"
                                        name="names"
                                        defaultValue={names}
                                        value={names}
                                        variant="outlined"
                                        onChange={(e) => {
                                            setNames(e.target.value)
                                        }}
                                    />
                                </Grid>
                                <Grid
                                    item
                                    md={6}
                                    xs={12}
                                >
                                    <TextField
                                        fullWidth
                                        label="Correo"
                                        name="email"
                                        type="email"
                                        defaultValue={userEmail}
                                        value={userEmail}
                                        variant="outlined"
                                        onChange={(e) => {
                                            setUserEmail(e.target.value)
                                        }}
                                    />
                                </Grid>
                                <Grid
                                    item
                                    md={6}
                                    xs={12}
                                >

                                    <TextField
                                        fullWidth
                                        label="Institución"
                                        name="names"
                                        defaultValue={institution!="NULL"?institution:''}
                                        value={institution!="NULL"?institution:''}
                                        variant="outlined"
                                        onChange={(e) => {
                                            setInstitution(e.target.value)
                                        }}
                                    />
                                </Grid>
                                <Grid
                                    item
                                    md={6}
                                    xs={12}
                                >
                                    <TextField
                                        fullWidth
                                        label="Rol/Materia"
                                        name="names"
                                        defaultValue={role != "NULL" ? role : ''}
                                        value={role != "NULL" ? role : ''}
                                        variant="outlined"
                                        onChange={(e) => {
                                            setRole(e.target.value)
                                        }}
                                    />
                                </Grid>

                                <Grid
                                    md={6}
                                    xs={12}
                                    className="gridStylingProfile"
                                >
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        onClick={(e) => { handleOpenRemoveDialog(username) }}
                                    >
                                        Eliminar Cuenta
                                    </Button>
                                </Grid>
                                <Grid
                                    md={6}
                                    xs={12}
                                    className="gridStyling2"
                                >
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={updateUser}
                                    >
                                        Guardar Cambios
                                    </Button>

                                </Grid>

                            </Grid>

                        </CardContent>
                    </Card>
                </div>
            </div>
            <div className='password-change' >
                <form className='password-change'
                    onSubmit={formik.handleSubmit}
                >
                    <Card className="cardStyling">
                        <CardHeader
                            title="Cambiar contraseña"
                        />

                        <Divider />

                        <CardContent>
                            <Grid
                                container
                                spacing={3}
                            >


                                <Grid
                                    item
                                    md={6}
                                    xs={12}
                                >

                                    <TextField
                                        fullWidth
                                        type="password"
                                        label="Nueva Contraseña"
                                        name="Nueva Contraseña"
                                        variant="outlined"
                                        {...formik.getFieldProps("Password")}
                                    />
                                    {formik.touched.Password && formik.errors.Password ? <span className="spanRed">{formik.errors.Password}</span> : null}


                                </Grid>
                                <Grid
                                    item
                                    md={6}
                                    xs={12}
                                >

                                    <TextField
                                        fullWidth
                                        type="password"
                                        label="Verificar Contraseña"
                                        name="VerifyPassword"
                                        variant="outlined"
                                        {...formik.getFieldProps("VerifyPassword")}
                                    />
                                    {formik.touched.VerifyPassword && formik.errors.VerifyPassword ? <span className="spanRed" >{formik.errors.VerifyPassword}</span> : null}

                                </Grid>
                                <Grid
                                    item
                                    md={6}
                                    xs={12}
                                >
                                    <TextField
                                        fullWidth
                                        type="password"
                                        label="Contraseña Actual"
                                        name="OldPassword"
                                        variant="outlined"
                                        {...formik.getFieldProps("OldPassword")}
                                    />
                                    {formik.touched.OldPassword && formik.errors.OldPassword ? <span className="spanRed">{formik.errors.OldPassword}</span> : null}

                                </Grid>

                                <Grid
                                    md={6}
                                    xs={12}
                                    className="gridStyling3"
                                >
                                    <Button className="buttonStyling" 
                                        variant="contained"
                                        color="primary"
                                        type="submit"
                                    >
                                        Guardar Cambios
                                    </Button>

                                </Grid>

                            </Grid>
                        </CardContent>
                    </Card>
                </form>
            </div>
            <div className='password-change'>
                <Card className="cardStyling">
                    <CardHeader
                        title="Tabla de puntuaciones de aprendizaje"
                    />

                    <Divider />
                    <CardContent>
                        <TblContainer>
                            <TblHead />
                            <TableBody>
                                {
                                    recordsAfterPagingAndSorting().map((item) => (

                                        <TableRow key={item.place}>
                                            <TableCell >{item.place}</TableCell>
                                            <TableCell >{item.username}</TableCell>
                                            <TableCell >{item.rank}</TableCell>
                                            <TableCell >{item.score}</TableCell>


                                        </TableRow>
                                    ))
                                }

                            </TableBody>
                        </TblContainer>
                        <TblPagination />
                    </CardContent>
                </Card>
            </div>
            <Snackbar open={openError} autoHideDuration={3000} onClose={handleClose}>
                <Alert onClose={handleClose} severity="error" className="alertStyling">
                    {error}
                </Alert>
            </Snackbar>
            <Snackbar open={openSuccess} autoHideDuration={3000} onClose={handleClose}>
                <Alert onClose={handleClose} severity="success" className="alertStyling">
                    {success}
                </Alert>
            </Snackbar>
            <Dialog
                open={openRemoveDialog}
                onClose={handleCloseRemoveDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Eliminar Usuario"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        ¿Está seguro que desea eliminar su cuenta?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={(e) => { deleteUser(removeUserID) }}>Sí</Button>
                    <Button onClick={handleCloseRemoveDialog} autoFocus>
                        No
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default AccountProfileDetails;